export default __webpack_public_path__ + "static/media/support-flag-stability.47b4543a.svg";